<h4 class="fd-subtitle">Fator</h4>

<form *ngIf="formGroup" [formGroup]="formGroup">
  <table mat-table [dataSource]="factorDataSource" class="fd-table">
    <ng-container matColumnDef="factorFlag" class="fd-table__cell">
      <th mat-header-cell *matHeaderCellDef class="fd-table__header">Bandeira</th>
      <td mat-cell *matCellDef="let row">{{ row.flag }}</td>
    </ng-container>

    <ng-container matColumnDef="factorTransaction" class="fd-table__cell">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fd-table__header">Transação</th>
      <td mat-cell *matCellDef="let row">{{ row.transaction }}</td>
    </ng-container>

    <ng-container matColumnDef="factorFee" class="fd-table__cell">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fd-table__header">Taxa</th>
      <td mat-cell #factorRow *matCellDef="let row; let i = index">
        <div formArrayName="factorFeeForms">
          <div [formGroupName]="i">
            <fd-fee-editor
              (openDialogFn)="openFactorFeeEditorModal($event, i)"
              [parentForm]="factorFeeFormsControls[i]"
              [field]="fieldsArray[i].suggestedFactorFee"
            ></fd-fee-editor>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="displayedFactorColumns"></tr>
    <tr mat-row class="fd-table__row" *matRowDef="let row; columns: displayedFactorColumns"></tr>
  </table>

  <ng-container *ngIf="mdrFlexLoaded">
    <h4 class="fd-subtitle">{{ getLabel() }}</h4>

    <table mat-table [dataSource]="mdrFlexGroupedDataSource" class="fd-table">
      <ng-container matColumnDef="flag" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Bandeira</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.flag === 'Todas'; else flagLogo"> Todas </ng-container>
          <ng-template #flagLogo>
            <img [class]="row.flag" [src]="getFlagImageURL(row.flag)" [alt]="row.flag" />
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="credito" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Crédito</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.credito as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>Adicional por parcela</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="debito" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Débito</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.debito as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>--</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="parceladoAte6" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Parcelamento em até 6x</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.parceladoAte6 as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>--</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="parceladoMais6" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Parcelamento mais de 6x</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.parceladoMais6 as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>--</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="crediario" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Crediário</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.crediario as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>--</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="voucher" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header fd-table__header--with-tip">
          <span>Voucher</span>

          <fa-icon
            *ngIf="hasVoucherMsg"
            mat-button
            icon="info-circle"
            size="1x"
            class="tooltip-voucher tooltip-icon"
            matTooltipClass="multiline-tooltip"
            [matTooltip]="getTextOfModalVoucher()"
            matTooltipPosition="right"
            (click)="$event.stopPropagation()"
            aria-label="Informação sobre Voucher"
          ></fa-icon>
        </th>

        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row?.voucher as cell; else emptyCell">
            <div formArrayName="mdrFlexFeeForms" class="fd-table__form-container">
              <div [formGroupName]="cell.index">
                <fd-fee-editor
                  [canEdit]="canEdit(cell.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, cell.index)"
                  [parentForm]="mdrFlexFeeFormsControls[cell.index]"
                  [field]="fieldsArray[cell.index].suggestedMdrFlexFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyCell>--</ng-template>
        </td>
      </ng-container>

      <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="displayedMdrFlexColumns"></tr>
      <tr mat-row class="fd-table__row" *matRowDef="let row; columns: displayedMdrFlexColumns"></tr>
    </table>
  </ng-container>
</form>

<div *ngIf="isPfacAccreditationType()" class="receiving-deadline-question">
  <h4 class="fd-subtitle">Qual o prazo de liquidação?</h4>
  <fd-radio-button [parentForm]="formGroup" [field]="fields.receivingDeadline"></fd-radio-button>
</div>

<div *ngIf="isCEF" class="cef-disclaimer">
  As condições comerciais apresentadas nesta simulação referem-se ao item 6 da Solicitação de Credenciamento à CAIXA Pagamentos/FISERV,
  estabelecidas de acordo com o faturamento informado para o novo domicílio e o ramo de atividade do cliente, as quais estão sujeitas a
  aprovação da credenciadora.
</div>

<fd-button *ngIf="!isCEF" fdSecondary [content]="'cancelar'" id="btnCancel" (trigger)="back()"> </fd-button>
<fd-button *ngIf="!isCEF" [content]="'avançar'" id="btnNext" (trigger)="next()"></fd-button>
<fd-button *ngIf="isCEF" [content]="'finalizar'" id="btnSave" (trigger)="saveSimulation()"></fd-button>
